"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/CircleSocialYoutubePlay.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CircleSocialYoutubePlay = function CircleSocialYoutubePlay(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "circle-icon",
    viewBox: "0 0 515 515"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "circle-social-you-tube-play"), _react2.default.createElement("g", {
    className: "youtube-play",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "circle",
    d: "M257.5-.33C115.29-.33 0 115 0 257.17s115.29 257.5 257.5 257.5S515 399.39 515 257.17 399.71-.33 257.5-.33zm124 279c0 27.22-4.29 42.95-14.35 52.58-9.81 9.39-25 13.22-52.36 13.22H200.21c-56.39 0-66.71-22.16-66.71-65.8v-42.96c0-22.53 0-38.8 8.69-49.85 8.92-11.33 25.73-15.95 58-15.95h114.6c31.57 0 48.09 4.34 57 15s9.67 27.06 9.67 50.82v42.93z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    className: "play",
    d: "M287.2 250l-52-27a8 8 0 0 0-11.69 7.1v54.21a8 8 0 0 0 11.71 7.09l52-27.19a8 8 0 0 0-.02-14.21z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  })));
};
exports.default = CircleSocialYoutubePlay;